<app-dialog-base class="modalcreateuser" [Title]='"Route"|translate' [dialogId]="dialogId" (onClose)="close()"
                 (onSubmit)="submit()">
  <div class="inputgroup">
    <label>{{'Name'|translate}}</label>
    <input type="text" placeholder="{{'Name'|translate}}" [(ngModel)]="model.Name"/>
  </div>
  <div class="inputgroup">
    <label>{{'Description'|translate}}</label>
    <input type="text" placeholder="{{'Description'|translate}}"  [(ngModel)]="model.Comment"/>
  </div>
  <div class="tableheader">{{'Waypoints'|translate}}</div>
  <div class="tablewrap">
    <div class="table tablewitharrows">
      <table fixedcols="[0, 2, 3]" id="routeslist">
        <tr>
          <th>&nbsp;</th>
          <th>{{'Name'|translate}}</th>
          <th>{{'Time to travel from previous point'|translate}}</th>
          <th><button (click)="addZone()" class="btn_img btn_graygray btn_plusorange"></button></th>
        </tr>
        <!-- TODO: what is updated it makes error -->
        <!-- <tr *ngFor="let stop of model.Stops | zoneOrder : updated">
          <td>
            <button (click)="pullUp(stop)" *ngIf="stop.Order > 0" class="btn_img btn_graygray btn_up"></button>
            <button (click)="pullDown(stop)" *ngIf="stop.Order < (model.Stops.length-1)" class="btn_img btn_graygray btn_down"></button>
          </td>
          <td>{{getZoneName(stop)}}</td>
          <td>{{getTime(stop)}}</td>
          <td>
            <button (click)="editZone(stop)" class="btn_img btn_edit"></button>
            <button (click)="removeZone(stop)" class="btn_img btn_remove"></button>
          </td>
        </tr> -->
      </table>
    </div>
  </div>
</app-dialog-base>
<template #mgmtDialog></template>
